import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainButton from "../../../commonComponents/MainButton";
import { ReactComponent as MagnifiyingGlass } from "../../../assets/navbar/MagnifyingGlass.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setOptimizationHistory } from "../../../redux/actions/optimizationActions";

const ReduceTopBar = ({ optimization_history, set_optimization_history_filterer, set_rand_update }) => {
  const [selected, setSelected] = useState(1);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const setOptimizationHistory_rd = (data) => dispatch(setOptimizationHistory(data));
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));

  function handleOnChangeSearchBar(value) {
    set_optimization_history_filterer(value.target.value);
    const filtred = Object.entries(optimization_history)
      .filter((x) => x[1].product_name.toLowerCase().includes(value.target.value))
      .reduce((acc, cur) => {
        acc[cur[0]] = cur[1];
        return acc;
      }, {});
    setOptimizationHistory_rd(filtred);
  }

  function handleOnChangeStatusFilter(value) {
    let filtred;
    switch (value) {
      case 1:
        filtred = optimization_history;
        break;
      case 2:
        filtred = Object.entries(optimization_history)
          .filter((x) => x[1].status === "onGoing")
          .reduce((acc, cur) => {
            acc[cur[0]] = cur[1];
            return acc;
          }, {});
        break;
      case 3:
        filtred = Object.entries(optimization_history)
          .filter((x) => x[1].status === "completed")
          .reduce((acc, cur) => {
            acc[cur[0]] = cur[1];
            return acc;
          }, {});
        break;
      default:
        return;
    }
    console.log("filtred", filtred);
    setOptimizationHistory_rd(filtred);
    set_rand_update(Math.random());
  }

  return (
    <>
      <div className="ml-[70px] h-[70px] bg-white flex items-center border-[#BEC4C]">
        <div className="ml-10 flex items-center justify-between">
          <p className="font-Poppins-SemiBold text-lg inline">Réduire - Scénarios traités</p>
        </div>
      </div>

      <div className="flex h-[80px] mt-10 bg-white mr-[95px] ml-[150px] items-center justify-between rounded-lg">
        <div className="flex flex-col items-center justify-center max-w-xl ml-[30px]">
          <ul className="flex space-x-2">
            <li>
              <a
                href="#"
                onClick={() => {
                  setSelected(1);
                  handleOnChangeStatusFilter(1);
                }}
                className={` ${selected === 1 ? "bg-mainGreen text-white" : "hover:bg-secondGreen bg-white text-gray-600"} font-medium inline-block px-4 py-2 rounded-full `}
              >
                Tous
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={() => {
                  setSelected(2);
                  handleOnChangeStatusFilter(2);
                }}
                className={`${selected === 2 ? "bg-mainGreen text-white" : "hover:bg-secondGreen bg-white text-gray-600"} font-medium inline-block px-4 py-2 rounded-full `}
              >
                En cours
              </a>
            </li>
            <li>
              <a
                href="#"
                onClick={() => {
                  setSelected(3);
                  handleOnChangeStatusFilter(3);
                }}
                className={` ${selected === 3 ? "bg-mainGreen text-white" : "hover:bg-secondGreen bg-white text-gray-600"} font-medium inline-block px-4 py-2 rounded-full `}
              >
                Terminée
              </a>
            </li>
          </ul>
          {/* <div className="p-3 mt-6 bg-white border">
            <div className={selected === 1 ? "block" : "hidden"}>
              {" "}
              React JS with Tailwind CSS Tab 1 Content show
            </div>
            <div className={selected === 2 ? "block" : "hidden"}>
              React JS with Tailwind CSS Tab 2 Content show
            </div>
            <div className={selected === 3 ? "block" : "hidden"}>
              React JS with Tailwind CSS Tab 3 Content show
            </div>
          </div> */}
        </div>

        <div className="flex">
          <input
            style={{ padding: 10 }}
            onChange={(value) => {
              handleOnChangeSearchBar(value);
            }}
            className="w-[400px] mx-10 rounded-md bg-[#F8FAFB] font-PoppinsLignt text-sm h-[35px]"
            type="text"
            placeholder="Rechercher le nom d'un produit..."
          />
        </div>

        <div className={"text-xs h-[35px] w-[200px] bg-mainGreen rounded-lg text-white font-Poppins-SemiBold flex justify-evenly items-center mr-[20px]"}>
          <MainButton
            disabled={user_info.organization_info.role.access.reduce.write}
            callback={() => navigate("/ReduceScenarioChoice")}
            title={"Créer une optimisation"}
            styleWind={"text-xs px-[10px]"}
          />
        </div>
      </div>
    </>
  );
};

export default ReduceTopBar;
